import { forwardRef } from 'react'
import './Input.css'

const Select = forwardRef(function Select({
  label,
  hint,
  error,
  className = '',
  children,
  id,
  ...props
}, ref) {
  const selectId = id || (label ? label.toLowerCase().replace(/\s+/g, '-') : undefined)
  const errorId = error && selectId ? `${selectId}-error` : undefined
  const hintId = !error && hint && selectId ? `${selectId}-hint` : undefined
  const describedBy = errorId || hintId || undefined
  const cls = [
    'form-select',
    error ? 'invalid' : '',
    className,
  ].filter(Boolean).join(' ')

  return (
    <div className="form-group">
      {label && <label htmlFor={selectId}>{label}</label>}
      <select
        ref={ref}
        id={selectId}
        className={cls}
        aria-invalid={error ? 'true' : undefined}
        aria-describedby={describedBy}
        {...props}
      >
        {children}
      </select>
      {error && <p id={errorId} className="field-error" role="alert">{error}</p>}
      {!error && hint && <p id={hintId} className="field-hint">{hint}</p>}
    </div>
  )
})

export default Select
